import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";
import { browserLabel } from "./browser-label";
import { BROWSER_ACT_VERBS } from "./browser-activity-constants";

/** "Clicked Se connecter" reads; "called browser_act" does not. */
export function describeBrowserAct(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const action = toolInput.str(record.action) ?? "click";
  const verb = (Object.hasOwn(BROWSER_ACT_VERBS, action)
    ? BROWSER_ACT_VERBS[action]
    : undefined) ?? {
    done: "Acted on",
    gerund: "Acting on",
    bare: "act on",
  };
  const target =
    toolInput.trimmed(record.name) ??
    toolInput.trimmed(record.selector) ??
    toolInput.trimmed(record.ref) ??
    toolInput.trimmed(record.role);
  const subject = target ? toolInput.truncate(target, 60) : "an element";
  return browserLabel(state, {
    failed: `Could not ${verb.bare} ${subject}`,
    running: `${verb.gerund} ${subject}`,
    done: `${verb.done} ${subject}`,
  });
}
